import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { Label } from "@root/shared/components/Label";
import { InformationText } from "@root/shared/components/InformationText";
import { TextField } from "@root/shared/components/TextField";
import { Icon } from "@root/shared/components/Icon";
import { colors } from "@root/shared/styles/sprinkles.css";
import { YearMonthSelect } from "@root/clientFrontend/features/contract/components/HoldEnquete/uiParts/YearMonthSelect";
import * as styles from "./styles.css";

type Props = {
  periodName: string;
  yearName: string;
  monthName: string;
  areaName: string;
  areaLabel: string;
  baseYear?: number;
  baseMonth?: number;
};

export const NewShopGroup: FC<Props> = ({
  periodName,
  yearName,
  monthName,
  areaName,
  areaLabel,
  baseYear,
  baseMonth,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const errorMessages = Array.from(
    new Set(
      [errors[periodName]?.message, errors[areaName]?.message].filter(
        (message): message is string => typeof message === "string",
      ),
    ),
  );

  return (
    <div className={styles.container}>
      <div className={styles.headingRow}>
        <p className={styles.heading}>
          新店オープン時期・エリアを教えてください
          <Label theme="red" className={styles.headingLabel}>
            必須
          </Label>
        </p>
        <p className={styles.note}>※どちらか片方の入力が必須です。</p>
      </div>
      {errorMessages.map((message) => (
        <InformationText key={message} text={message} isAlert />
      ))}
      <div className={styles.questions}>
        <div className={`${styles.card} ${styles.periodCard}`}>
          <YearMonthSelect
            yearName={yearName}
            monthName={monthName}
            baseYear={baseYear}
            baseMonth={baseMonth}
            hasError={!!errors[periodName]}
          />
        </div>
        <div className={styles.card}>
          <div className={styles.labelRow}>
            <Icon name="location" fontSize="16px" color={colors.TextLight} />
            <p className={styles.label}>{areaLabel}</p>
          </div>
          <TextField
            {...register(areaName)}
            placeholder="例）東京都渋谷区"
            hasError={!!errors[areaName]}
            className={styles.textField}
          />
        </div>
      </div>
    </div>
  );
};
